<template>
    <div class="animated fadeIn">
       <AppHeader/>
       <div class="app-body">
          <main class="main" style="margin-left:0!important">
             <breadcrumb :list="list" />
             <div class="container-fluid">
                <b-row class="bg-gray-100">
                   <b-col md="12" class="text-center mb-3">
                      <br>
                      <h1 class="display-3 font-weight-bold">Open Data Challenge</h1>
                      <p>
                      <h3 class="font-weight-normal"> CHARLOTTESVILLE, VA </h3>
                      </p>

                      This is the first "City Open Data Challenge" co-sponsored by <a href="https://www.astraea.earth/">Astraea</a> with the goal of gaining a better understanding of the pedestrian use of the Downtown Mall. <p> This website shares discoveries related to WiFi usage on the Downtown Mall. </p><br><br>
                      <img src="https://image.ibb.co/dBias7/HOMEPAGE_ARROW.png" class="img-fluid">
                   </b-col>
                </b-row>

                <b-row class="bg-gray-100 justify-content-center">
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/m4Z7qS/generalstat1.png" class="img-fluid">
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/ejzwjn/generalstat2.png" class="img-fluid" />
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/mUGbjn/generalstats4.png" class="img-fluid" />
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://preview.ibb.co/fgCKen/8_Wifi.png" class="img-fluid" /> 
                      <br>
                      <br>                  
                   </b-col>
                </b-row>
                <b-row class="bg-gray-100 justify-content-center">
                   <b-col lg="8" md="8" sm="12" class="text-center mb-3">
                      <carousel :perPage="1" :navigateTo="someLocalProperty" :navigationEnabled="true" navigationPrevLabel=""  navigationNextLabel="" paginationColor="#9dacb1" class="img-fluid">
                         <slide>
                            <img src="https://image.ibb.co/gAW5Px/panel1.png" alt="Why" class="w-90 img-fluid">
                         </slide>
                         <slide>
                            <img src="https://image.ibb.co/kRvArc/panel2.png" alt="Understand" class="w-90 img-fluid">
                         </slide>
                         <slide>
                            <img src="https://image.ibb.co/eXkArc/panel3.png" alt="Grow" class="w-90 img-fluid">
                         </slide>
                         <slide>
                            <img src="https://image.ibb.co/it8Vrc/panel4.png" alt="Improve" class="w-90 img-fluid">
                         </slide>
                         <slide>
                            <img src="https://image.ibb.co/hjT8cH/panel5.png" alt="Give" class="w-90 img-fluid">
                         </slide>
                      </carousel>
                   </b-col>
                </b-row>
                <br>
                
                <div class="row">
                   <div class="col" md="1"></div>
                   <div class="col text-center justify-content-center align-self-center">
                    <router-link :to="'story'" class="btn btn-primary btn-block btn-color-orange p-4 mb-4 ">VIEW OUR STORY</router-link>
                   </div>
                  <!-- <div class="col">
                      <router-link :to="'story'" class="btn btn-primary btn-block btn-color-blue">VIEW OUR MODEL</router-link>
                   </div> -->
                   <div class="col" md="1"></div>
                </div>
                </b-row>


              <b-card>
                <b-row>
                   <b-col md="12" class="text-center">
                      <h1 class="display-4">Meet the Team</h1>
                      <p>
                      <h2 class="font-weight-normal"> "H.A.C.K.D." </h2>
                      </p>
                   </b-col>
                </b-row>
                <b-row class="">
                   <b-col md="12" class="text-center mb-3">
                      <p>
                         We would like to extend our sincere thanks and appreciation to <a href="https://www.astraea.earth/">Astraea</a> for creating and co-sponsoring this wonderful competition. We are honored to be among the participants and excited to share our ideas and results.
                      </p>
                   </b-col>
                </b-row>
                <b-row lg="2" md="2"  class="justify-content-center">
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/m2zNpn/Halee_Mason.jpg" class="image--cover">
                      <h4><a href= "https://www.linkedin.com/in/haleemason/">Halee Mason</a></h4>
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/fCbDvS/Anna_Godwin.jpg" alt="" class="image--cover" />
                      <h4><a href="https://www.linkedin.com/in/anna-godwin-a51284140/">Anna Godwin</a></h4>
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/iArfaS/Cory_Everington.jpg" alt="" class="image--cover" />
                      <h4><a href="https://www.linkedin.com/in/coryeverington/">Cory Everington</a></h4>
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="static/img/Kazlin_Mason.jpg" alt="" class="image--cover" />
                      
                      <h4><a href="https://www.linkedin.com/in/kazlin/">Kazlin Mason</a></h4>
                   </b-col>
                   <b-col sm="6" lg="2" class="text-center">
                      <img src="https://image.ibb.co/fq0v9n/Danny_Brady.jpg" alt="" class="image--cover" />
                      <h4><a href="https://www.linkedin.com/in/danny-brady-514965a4/">Danny Brady</a></h4>
                   </b-col>
                </b-row>
                <br>
                <br>
              </b-card>
                <br>
             </div>
          </main>
          <AppAside/>
       </div>
       <AppFooter class="m-0 height-50"/>
    </div>
 </template>

<script>
import nav from '../_nav'
import { Header as AppHeader, Sidebar, Aside as AppAside, Footer as AppFooter, Breadcrumb } from '../components/'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'home',
  components: {
    AppHeader,
    Sidebar,
    AppAside,
    AppFooter,
    Breadcrumb,
    Carousel,
    Slide
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched
    }
  }
}
</script>

<style>
.background-color-gray{
  background: #e4e5e6
}
.VueCarousel-pagination {
  margin-top: -20px;
}
.navbar-toggler-icon {
  display: none;
}
.w-800 {
  width: 800px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue